export default __webpack_public_path__ + "static/media/0x1eba4b44c4f8cc2695347c6a78f0b7a002d26413.6f2ecef0.webp";